import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import styles from "./index.module.scss";
import { Tabs } from '@arco-design/web-react';
import loadable from 'react-loadable'
import NoSSR from 'react-no-ssr';
import classNames from "classnames";
import LazyMedia from "@/components/LazyMedia";

const CustomSwiper = loadable({
  loader: () => import('@/components/CustomSwiper'),
  loading: () => <div></div>,
})

const TabPane = Tabs.TabPane;
const carousel = require('../../assets/soft_bg_pico_link 1.png')
const carousel1 = require('../../assets/soft_bg_pico_link 2.png')
interface ISoftware{
  picoAssistantList: Record<string, any>[]; // Streaming下载列表
  picoRemotePlaybackList: Record<string, any>[]; // RemotePlay下载列表
  words: Record<string, string>;
}
const Carousel:React.FC<ISoftware> = ({picoAssistantList, picoRemotePlaybackList,words}) => {
  const location = useLocation();

  // 监听hash变化，滚动到锚点
  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView();
      }
    }
  }, [location]);


    return (
      <>
      {/* PICO Assistant */}
      <div className={styles.carousel}>
        <div className={styles.carouselTittle} id="assistant">
          <p className={styles.textTittle}>{words.software_Assistant_title}</p>
          <p className={styles.textContent}>{words.software_Assistant_content}</p>
        </div>
        <div className={styles.carouselContent}>
          <NoSSR>
            <CustomSwiper
              spaceBetween={36}
              swiperWrapClass={styles['custom-swiper-wrap']}
              swiperSlideClass={styles["custom-swiper-slider"]}
              isHidePagination={false}>
              <div className={styles.carouselItem}>
                <LazyMedia type="image" src={carousel} alt="" className={styles.carouselImg}/>
              </div>
              <div className={styles.carouselItem1}>
                <div className={styles.carouselItem1Content}>
                  <p className={styles.downloadDetailTittle}>{words.software_Assistant_dialogTitle}</p>
                  <Tabs  type='rounded'>
                    {picoAssistantList.map((data:any,index:number) => (
                      <TabPane key={index} title={data.title}>
                        <a className={styles.downloadBtn} href={data.url} download={data.title}>{words.software_download}</a>
                        <div className={styles.downloadDetails}>
                          <div className={classNames(
                            styles.downloadDetailsText,
                            styles['dowmload-info-left']
                          )}>
                              <h3>{words.software_Notes}</h3>
                              <div className={styles.downloadDetailsTextContent}>
                                {data.updateInfo}
                              </div>
                              <h3>{words.software_New}</h3>
                              <div className={styles.downloadDetailsTextContent}>
                                {data.updateContent}
                              </div>
                          </div>
                          <div className={classNames(
                            styles.downloadDetailsText,
                            styles['dowmload-info-right']
                          )}>
                              <h3>{words.software_Requirements}</h3>
                              <div className={styles.downloadDetailsTextContent}>
                                {data.configurationRequirements}
                              </div>
                          </div>
                        </div>
                      </TabPane>
                    ))}
                  </Tabs>
                </div>
              </div>
            </CustomSwiper>
          </NoSSR>
        </div>
      </div>

      {/* PICO Remote Playback */}
      <div className={styles.carousel1}>
        <div className={styles.carouselTittle1} id="remote">
          <p className={styles.textTittle}>{words.software_Playback_title}</p>
          <p className={styles.textContent}>{words.software_Playback_content}</p>
        </div>
        <div className={styles.carouselContent}>
          <NoSSR>
            <CustomSwiper
              spaceBetween={36}
              swiperWrapClass={styles['custom-swiper-wrap']}
              swiperSlideClass={styles["custom-swiper-slider"]}
              isHidePagination={false}>
                <div className={styles.carouselItem}>
                  <LazyMedia type="image" src={carousel1} alt="" className={styles.carouselImg}/>
                </div>

                <div className={styles.carouselItem1}>
                  <div className={styles.carouselItem1Content}>
                    <p className={styles.downloadDetailTittle}>{words.software_Playback_dialogTitle}</p>
                    <Tabs  type='rounded'>
                      {picoRemotePlaybackList.map((data:any,index:number) => (
                        <TabPane key={index} title={data.title}>
                          <a className={styles.downloadBtn} href={data.url} download={data.title}>{words.software_download}</a>
                          <div className={styles.downloadDetails}>
                            <div className={classNames(
                              styles.downloadDetailsText,
                              styles['dowmload-info-left']
                            )}>
                                <h3>{words.software_Notes}</h3>
                                <div className={styles.downloadDetailsTextContent}>
                                  {data.updateInfo}
                                </div>
                                <h3>{words.software_New}</h3>
                                <div className={styles.downloadDetailsTextContent}>
                                  {data.updateContent}
                                </div>
                            </div>
                            <div className={classNames(
                              styles.downloadDetailsText,
                              styles['dowmload-info-left']
                            )}>
                                <h3>{words.software_Requirements}</h3>
                                <div className={styles.downloadDetailsTextContent}>
                                  {data.configurationRequirements}
                                </div>
                            </div>
                          </div>
                        </TabPane>
                      ))}
                    </Tabs>
                  </div>
                </div>
            </CustomSwiper>
          </NoSSR>
        </div>
      </div>
      </>
    );
  };
  export default Carousel;
